import { useContext, useMemo } from 'react';

import { Mode } from 'src/modules/designStudio/providers';
import { context } from 'src/modules/designStudio/providers/ModeProvider';

export const useShowRealProductSelectionUI = () => {
  const { mode } = useContext(context);

  return useMemo(() => mode === Mode.DEFAULT || mode === Mode.GUEST, [mode]);
};
